import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Info } from 'lucide-react';

interface InfoTooltipProps {
  /** Explanation shown on hover, keyboard focus, or click/tap. */
  description: string;
  label?: string;
}

/** Small "i" icon that reveals a description on hover or click, so long help text does not clutter forms. */
export const InfoTooltip: React.FC<InfoTooltipProps> = ({ description, label = 'More info' }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <Tooltip
      title={description}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      placement="top"
      arrow
      enterTouchDelay={0}
      leaveTouchDelay={5000}
    >
      <IconButton
        size="small"
        aria-label={label}
        onClick={() => setOpen((current) => !current)}
        edge="end"
      >
        <Info size={18} />
      </IconButton>
    </Tooltip>
  );
};
